import React from 'react';
import { Helmet } from 'react-helmet-async';
import JacksonStateSoccerArticle from '../components/JacksonStateSoccerArticle';

/**
 * Jackson State Soccer Article Page
 * A dedicated page for the interactive Jackson State Women's Soccer feature
 */
const JacksonStateSoccerPage = () => {
  return (
    <>
      <Helmet>
        <title>Jackson State Soccer: Built for the SWAC Race | SheLovesThee</title>
        <meta name="description" content="Jackson State challenged itself outside the conference, found its attack late in the non-conference slate, and opened SWAC play by shutting out rival Southern." />
        <meta property="og:title" content="Jackson State Soccer: Built for the SWAC Race" />
        <meta property="og:description" content="The defending SWAC regular-season champions are back in the hunt. Meet the 2026 Jackson State Tigers." />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <JacksonStateSoccerArticle />
    </>
  );
};

export default JacksonStateSoccerPage;
